import { Fragment } from 'react';

import { CardHeader } from '@playbooks/ui/components/card';
import { CardMedia } from '@playbooks/ui/components/card';
import { Icon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

const CollectionCardHeader = ({ layout = 'grid', collection }) => {
	const bookmarks = collection.bookmarks?.data || collection.bookmarks || [];
	const items = bookmarks.map(bookmark => bookmark.template || bookmark.project).filter(Boolean);

	// Theme
	const sizeClassName = (() => {
		switch (layout) {
			case 'grid':
				return 'w-full';
			case 'detail':
				return 'w-full';
			case 'display':
				return 'm-4 p-2 w-14';
			case 'list':
				return 'w-20 lg:w-24';
			case 'photo':
				return 'w-full';
			case 'pill':
				return 'w-18';
			case 'preview':
				return 'w-12';
			case 'select':
				return 'w-12';
			default:
				return 'w-10';
		}
	})();
	const classNames = {
		photo: cn('aspect-[16/9] flex-middle overflow-hidden p-0', sizeClassName),
		grid: cn('aspect-[16/9] overflow-hidden p-0', sizeClassName),
		fallback: cn('aspect-[16/9] flex-middle overflow-hidden p-2', sizeClassName),
	};

	// Render
	return (
		<Fragment>
			{collection.thumbnail && !(layout === 'grid' && items.length > 0) ? (
				<CardHeader className={classNames.photo}>
					<img src={collection.thumbnail} alt={collection.name} />
				</CardHeader>
			) : items.length > 0 ? (
				<CardHeader className={classNames.grid}>
					<div className='grid h-full w-full grid-cols-2'>
						{items.slice(0, 4).map((item, i) => (
							<div key={i} className='col-span-1 min-h-0 border-border odd:border-r [&:nth-child(-n+2)]:border-b'>
								<img src={item.thumbnail} alt={item.name} className='h-full w-full object-cover' />
							</div>
						))}
					</div>
				</CardHeader>
			) : (
				<CardHeader className={classNames.fallback}>
					<CardMedia>
						<Icon type='fad' icon={'layer-group'} aria-hidden />
					</CardMedia>
				</CardHeader>
			)}
		</Fragment>
	);
};
export { CollectionCardHeader };
